export const validateFuture = (value?: Date | null) => !value || value >= new Date();
